import type { BodyRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type AbuseReportCreateRequestBody = paths['/v3/abuse_reports']['post']['requestBody']['content']['application/json'];
type ResponseType = paths['/v3/abuse_reports']['post']['responses'];

export const createAbuseReport = async ({ body }: BodyRequest<AbuseReportCreateRequestBody>) =>
  apiClient.post<ResponseType, ApiClientResponse<ResponseType>>(routes.report, body);
